import { Form, Button, Modal } from "react-bootstrap";
import { FiPlus } from "react-icons/fi";
import { groupAndProjectServices } from "../../../APIServices/WorkBridge/TeamManagement/groupAndProjectServices";
import { useState } from "react";

const AddProject = ({ Show, Hide, Title, isDark, getGroupAndProjectList }) => {
  const [loader, setLoader] = useState(false)
  const [projectName, setProjectName] = useState("")
  const [projectDescription, setProjectDescription] = useState("")
  const [projectType, setProjectType] = useState("public")

  const addNewGroupAndProject = async () => {
    let userData = {}
    setLoader(true)
    userData.name = projectName
    userData.description = projectDescription
    userData.type = projectType
    userData.category = "project"
    let data = await groupAndProjectServices.addNewGroupAndProject(userData)
    if (data?.statusCode === 200) {
      setLoader(false)
      setProjectName("")
      setProjectDescription("")
      setProjectType("")
      getGroupAndProjectList()
      Hide()
    }
  }
  return (
    <Modal show={Show} onHide={Hide} size="md">
      <Modal.Header
        closeButton
        className={`${isDark ? "bg-dark text-light" : "bg-light"} p-3 border-bottom`}
      >
        <Modal.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className={`rounded-bottom ${isDark ? "bg-dark" : "bg-white"}`}
      >
        <Form.Group className="mb-2">
          <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
            Project Name
          </Form.Label>
          <Form.Control
            type="text"
            onChange={(e) => setProjectName(e.target.value)}
            value={projectName}
            className="interactive-input"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Project Description"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
            Project Description
          </Form.Label>
          <Form.Control
            as="textarea"
            row={3}
            onChange={(e) => setProjectDescription(e.target.value)}
            value={projectDescription}
            className="interactive-input"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Project Description"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-0 fw-bold" style={{ fontSize: 13 }}>
            Project Type
          </Form.Label>
          <Form.Select
            onChange={(e) => setProjectType(e.target.value)}
            value={projectType}
            style={{ fontSize: 12 }}>
            <option value={"public"}>Public</option>
            <option value={`private`}>Private</option>
          </Form.Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <div className="hstack justify-content-end">
          <Button
            variant="outline-primary"
            style={{ fontSize: 13 }}
            title={Title}
            onClick={addNewGroupAndProject}
            disabled={!projectName || !projectDescription || !projectType || loader}
            className="rounded-1 py-1 px-3 text-nowrap hstack gap-2"
          >
            <FiPlus />
            Add New
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddProject;
